/** Resource da API dos KPIs dos representantes */
export const REPRESENTANTES_KPIS_API_RESOURCE = 'representantes';
/** Resource da API dos KPIs de produtividade dos representantes */
export const REPRESENTANTES_PRODUTIVIDADE_KPIS_API_RESOURCE = `${REPRESENTANTES_KPIS_API_RESOURCE}/produtividade`;
/** Resource da API dos KPIs das modalidades comerciais */
export const REPRESENTANTES_MODALIDADES_COMERCIAIS_KPIS_API_RESOURCE = `${REPRESENTANTES_KPIS_API_RESOURCE}/modalidades-comerciais`;
